import { NgModule } from '@angular/core'
import { MultiSelectModule } from 'primeng/components/multiselect/multiselect'
import { ProgressBarModule } from 'primeng/components/progressbar/progressbar'
import { SliderModule } from 'primeng/components/slider/slider'

@NgModule({
  exports: [SliderModule, MultiSelectModule, ProgressBarModule]
})
export class PrimeModule {}
